<div
    class="cw-flex-row"
    [ngClass]="{'cw-menu-expanded-left': globalMenuExpanded, 'cw-menu-expanded-right': submodulesMenuExpanded}">
    <phscw-global-menu class="cw-flex-column cw-background-orange cw-color-white"></phscw-global-menu>
    <div class="cw-flex-column">
        <phscw-global-header class="cw-flex-row cw-background-orange cw-color-white"></phscw-global-header>
        <div>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
